import dotenv from 'dotenv'
import aws from 'aws-sdk'


dotenv.config()

const bucketName = "help-and-support"

const s3 = new aws.S3({
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  region: "us-west-2",
  signatureVersion: "v4"
})

export async function generateUploadURL(name) {
  
  const imageName = "dev-incident-files/"+name;

  const params = ({
    Bucket: bucketName,
    Key: imageName,
    Expires: 60
  })
  
  const uploadURL = await s3.getSignedUrlPromise('putObject', params)
  return uploadURL
}